<template>
    <div v-if="client">
        <!-- casino home banner -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show casino home banner</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.casinoHomeBanner"
                                   type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- casino home custom banner -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show casino home custom banner</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.casinoHomeCustomBanner"
                                   type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- casino home custom banner images -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Casino home custom banner images</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <draggable :list="client.settings.viewSettings.banners.casinoHomeCustomBannerImages">
                            <div v-for="(img, i) in client.settings.viewSettings.banners.casinoHomeCustomBannerImages"
                                 :key="img"
                                 class="banner-image">
                                <div class="field has-addons">
                                    <p class="control">
                                        <span class="icon is-medium">
                                            <i class="fas fa-grip-vertical"></i>
                                        </span>
                                    </p>
                                    <p class="control">
                                        <input v-model="client.settings.viewSettings.banners.casinoHomeCustomBannerImages[i].image"
                                               class="input is-small"
                                               type="text"
                                               placeholder="image" />
                                    </p>
                                    <p class="control">
                                        <input v-model="client.settings.viewSettings.banners.casinoHomeCustomBannerImages[i].link"
                                               class="input is-small"
                                               type="text"
                                               placeholder="link" />
                                    </p>
                                    <p class="control">
                                        <a @click="deleteCasinoHomeCustomBannerImage(i)"
                                           class="button is-small">del</a>
                                    </p>
                                </div>
                            </div>
                        </draggable>
                        <a @click="addCasinoHomeCustomBannerImage()" class="button is-small">add</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- casino home custom banner 2 -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show casino home custom banner 2</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.casinoHomeCustomBanner2"
                                   type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- casino home custom banner images 2 -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Casino home custom banner images 2</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <draggable :list="client.settings.viewSettings.banners.casinoHomeCustomBannerImages2">
                            <div v-for="(img, i) in client.settings.viewSettings.banners.casinoHomeCustomBannerImages2"
                                 :key="img"
                                 class="banner-image">
                                <div class="field has-addons">
                                    <p class="control">
                                        <span class="icon is-medium">
                                            <i class="fas fa-grip-vertical"></i>
                                        </span>
                                    </p>
                                    <p class="control">
                                        <input v-model="client.settings.viewSettings.banners.casinoHomeCustomBannerImages2[i].image"
                                               class="input is-small"
                                               type="text"
                                               placeholder="image" />
                                    </p>
                                    <p class="control">
                                        <input v-model="client.settings.viewSettings.banners.casinoHomeCustomBannerImages2[i].link"
                                               class="input is-small"
                                               type="text"
                                               placeholder="link" />
                                    </p>
                                    <p class="control">
                                        <a @click="deleteCasinoHomeCustomBannerImage2(i)"
                                           class="button is-small">del</a>
                                    </p>
                                </div>
                            </div>
                        </draggable>
                        <a @click="addCasinoHomeCustomBannerImage2()" class="button is-small">add</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- sport home banner -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show sport home banner</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.sportHomeBanner"
                                   type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        
        <!-- sport custom banner images -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sport custom banner images</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.sportCustomBanner" type="checkbox" />
                        </label>
                        <banners-draggable :banners="client.settings.viewSettings.banners.sportCustomBannerImages" />
                    </p>
                </div>
            </div>
        </div>
        
        <!-- registration banner -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show registration banner</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.registrationBanner"
                                   type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- sport leeft column bottom banners -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sport left column bottom banners</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.sportLeftColumnBottomBannersEnabled" type="checkbox" />
                        </label>
                        <banners-draggable :banners="client.settings.viewSettings.banners.sportLeftColumnBottomBanners" />
                    </p>
                </div>
            </div>
        </div>

        <!-- sport right column bottom banners -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sport right column bottom banners</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.sportRightColumnBottomBannersEnabled" type="checkbox" />
                        </label>
                        <banners-draggable :banners="client.settings.viewSettings.banners.sportRightColumnBottomBanners" />
                    </p>
                </div>
            </div>
        </div>

        <!-- sport autoexpress desktop banners -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sport autoexpress desktop banners</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.sportAutoexpressDesktopBannerEnabled" type="checkbox" />
                        </label>
                        <banners-draggable :banners="client.settings.viewSettings.banners.sportAutoexpressDesktopBannerImages" />
                    </p>
                </div>
            </div>
        </div>

        <!-- sport autoexpress mobile banners -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sport autoexpress mobile banners</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.sportAutoexpressMobileBannerEnabled" type="checkbox" />
                        </label>
                        <banners-draggable :banners="client.settings.viewSettings.banners.sportAutoexpressMobileBannerImages" />
                    </p>
                </div>
            </div>
        </div>

        <!-- deposit banner -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show deposit banner</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.depositBanner"
                                   type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- ITechLabs banner -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">ITechLabs banner</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.viewSettings.banners.iTechLabsBanner"
                                   type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import state from '../../../../../state';
    import utils from '../../../../../utils';
    import clientService from '../../../../../services/client.service';

    import draggable from 'vuedraggable';
    import bannersDraggable from './banners-draggable.vue';

    export default {
        name: 'client-settings-view-banners',
        components: { draggable, bannersDraggable },
        data() {
            return {
                client: null
            };
        },
        computed: {
            clientId() {
                return Number(this.$route.params.clientId);
            }
        },
        watch: {
            clientId() {
                this.loadClient();
            }
        },
        async mounted() {
            await clientService.ensure();
            this.loadClient();
        },
        methods: {
            loadClient() {
                this.client = utils.clone(state.clients.getClient(this.clientId));
            },
            addCasinoHomeCustomBannerImage() {
                this.client.settings.viewSettings.banners.casinoHomeCustomBannerImages.push({
                    image: '',
                    link: ''
                });
            },
            deleteCasinoHomeCustomBannerImage(i) {
                this.client.settings.viewSettings.banners.casinoHomeCustomBannerImages.splice(i, 1);
            },
            addCasinoHomeCustomBannerImage2() {
                this.client.settings.viewSettings.banners.casinoHomeCustomBannerImages2.push({
                    image: '',
                    link: ''
                });
            },
            deleteCasinoHomeCustomBannerImage2(i) {
                this.client.settings.viewSettings.banners.casinoHomeCustomBannerImages2.splice(i, 1);
            },
            addSportCustomBannerImage() {
                this.client.settings.viewSettings.banners.sportCustomBannerImages.push({
                    image: '',
                    link: ''
                });
            },
            deleteSportCustomBannerImage(i) {
                this.client.settings.viewSettings.banners.sportCustomBannerImages.splice(i, 1);
            },
            async save() {
                await clientService.save(this.client);
                this.loadClient();
            }
        }
    };
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/banners.vue